import { limitTextLength } from './inputLimits';

const BASIC_HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export const escapeHtml = (value: string): string =>
  value.replace(/[&<>"']/g, (ch) => BASIC_HTML_ESCAPE_MAP[ch] ?? ch);

export const sanitizePlainText = (value: string, maxLength = 500): string => {
  return escapeHtml(limitTextLength(value, maxLength)).trim();
};
